export default __webpack_public_path__ + "static/media/materials.428c6d07.png";